import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FlexColumn, FlexRow } from 'web-ui-components/lib/global/layout';

import accountPropTypes from '../../../states/accounts/propTypes';
import managePayeeListContent, {
	contentPropTypes,
} from '../../../managePayee/components/managePayeeList/managePayeeList.content';
import withContent from '../../../containers/withContent';
import { payeePropTypes } from '../../../sharedComponents/FromToPayeeSelector/propTypes';
import FileUploadFeatureFlag from '../../../sharedComponents/FileUploadFeatureFlag/FileUploadFeatureFlag';
import FileImport from '../../../sharedComponents/FileImport/FileImport';
import { CONST_FILE_UPLOAD } from '../../../config/constants';
import PickerPagingView from '../PickerPagingView/PickerPagingView';

export class PayeePickerViewForManageYourPayee extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isImportPayeesModalOpen: false,
		};
		this.handleImportNowClick = this.handleImportNowClick.bind(this);
		this.handleOncloseClick = this.handleOncloseClick.bind(this);
	}

	handleImportNowClick() {
		this.setState({ isImportPayeesModalOpen: true });
	}
	handleOncloseClick() {
		this.setState({ isImportPayeesModalOpen: false });
	}
	render() {
		const {
			pageLoading,
			currentPage,
			totalNumberOfPages,
			onPageChanged,
			listViewSelected,
			accounts,
			onRetry,
			error,
			accountsNeverFetched,
			layoutType,
			payees,
			showPayees,
			handlePayeeSelect,
			getIsPayeeSelected,
			onFavouriteIconClick,
			isManageYourPayee,
			handleViewPayee,
			handleDeletePayee,
			handleEditPayee,
			handleEditChaps,
			handleImportPayees,
			isFileImportAllowed,
			handleTransferPayee,
			content,
			searchText,
			payeesNeverFetched,
			isBootStrapInProgress,
		} = this.props;
		return (
			<div className="payee-picker-paging-view">
				<FlexRow>
					<FlexColumn proportion={3}>
						<PickerPagingView
							currentPage={currentPage}
							totalNumberOfPages={totalNumberOfPages}
							pageLoading={pageLoading}
							onPageChange={onPageChanged}
							payees={payees}
							listViewSelected={listViewSelected}
							onFavouriteIconClick={onFavouriteIconClick}
							error={error}
							onRetry={onRetry}
							searchText={searchText}
							accountsNeverFetched={accountsNeverFetched}
							layoutType={layoutType}
							showPayees={showPayees}
							accounts={accounts}
							handlePayeeSelect={handlePayeeSelect}
							getIsPayeeSelected={getIsPayeeSelected}
							isManageYourPayee={isManageYourPayee}
							handleViewPayee={handleViewPayee}
							handleDeletePayee={handleDeletePayee}
							handleEditPayee={handleEditPayee}
							handleEditChaps={handleEditChaps}
							handleImportPayees={handleImportPayees}
							isFileImportAllowed={isFileImportAllowed}
							handleTransferPayee={handleTransferPayee}
							payeesNeverFetched={payeesNeverFetched}
							isBootStrapInProgress={isBootStrapInProgress}
						/>
					</FlexColumn>

					<FlexColumn proportion={1}>
						{isFileImportAllowed && (
							<FileUploadFeatureFlag path={CONST_FILE_UPLOAD.BENEFICIARY}>
								<FileImport content={content} />
							</FileUploadFeatureFlag>
						)}
					</FlexColumn>
				</FlexRow>
			</div>
		);
	}
}

PayeePickerViewForManageYourPayee.propTypes = {
	pageLoading: PropTypes.bool.isRequired,
	currentPage: PropTypes.number.isRequired,
	totalNumberOfPages: PropTypes.number.isRequired,
	onPageChanged: PropTypes.func.isRequired,
	listViewSelected: PropTypes.bool.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	content: PropTypes.shape(contentPropTypes),
	onFavouriteIconClick: PropTypes.func.isRequired,
	error: PropTypes.bool.isRequired,
	onRetry: PropTypes.func.isRequired,
	accountsNeverFetched: PropTypes.bool.isRequired,
	layoutType: PropTypes.string.isRequired,
	showPayees: PropTypes.bool.isRequired,
	payees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	handlePayeeSelect: PropTypes.func,
	getIsPayeeSelected: PropTypes.func,
	payeesNeverFetched: PropTypes.bool,
	isBootStrapInProgress: PropTypes.bool,
	isManageYourPayee: PropTypes.bool,
	handleViewPayee: PropTypes.func,
	handleDeletePayee: PropTypes.func,
	handleEditPayee: PropTypes.func,
	handleImportPayees: PropTypes.func,
	isFileImportAllowed: PropTypes.bool,
	handleTransferPayee: PropTypes.func,
	searchText: PropTypes.string,
};

export default withContent({ content: managePayeeListContent })(PayeePickerViewForManageYourPayee);
